import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e8b7200"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-10",
    style: {"font-size":"0.8rem","font-weight":"700"}
  }, [
    /*#__PURE__*/_createElementVNode("p", { class: "mb-0 me-3" }, "Công ty: ..........................................."),
    /*#__PURE__*/_createElementVNode("p", null, "Chi nhánh: ...........................................")
  ])
], -1))
const _hoisted_3 = { class: "row mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-center fw-bolder text-uppercase" }, " bảng kê chi tiết xuất ", -1))
const _hoisted_7 = {
  class: "text-center mb-1 fst-italic",
  style: {"font-size":"0.8rem"}
}
const _hoisted_8 = {
  class: "text-center mb-0",
  style: {"font-size":"0.9rem"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_10 = {
  class: "text-center",
  style: {"font-size":"0.9rem"}
}
const _hoisted_11 = { class: "mx-2" }
const _hoisted_12 = { class: "mx-2" }
const _hoisted_13 = { class: "mx-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-end mb-0 fst-italic",
  style: {"font-size":"0.8rem"}
}, "ĐVT: đồng", -1))
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = {
  class: "d-flex justify-content-between mx-5 align-items-end",
  style: {"font-size":"0.8rem"}
}
const _hoisted_18 = { class: "flex flex-column justify-content-end align-items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-center my-2 fst-italic",
  style: {"font-size":"0.8rem"}
}, " Ngày ..... tháng ..... năm ..... ", -1))

import { computed, getCurrentInstance, PropType, ref } from 'vue';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { IBangKeChiTietXuatResponseBase, ICapSuaChuaResponseBase, IKhoResponseBase, IToaXeResponseBase } from '@/core/interfaces/ApiResponses';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import ChiTietXuatTable from '../table-components/ChiTietXuatTable.vue';
import DivCol from '@/layout/_shared/DivCol.vue';
import DivRow from '@/layout/_shared/DivRow.vue';
import SignatureCol from '@/layout/_shared/SignatureCol.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BangKeChiTietXuatPrintModal',
  props: {
  capSuaChua: {
    type: Object as PropType<ICapSuaChuaResponseBase | null>,
    default: null,
  },
  from: {
    type: Date,
    default: new Date(),
  },
  items: {
    type: Array as PropType<IBangKeChiTietXuatResponseBase[]>,
    default: () => [],
  },
  kho: {
    type: Object as PropType<IKhoResponseBase | null>,
    default: null,
  },
  to: {
    type: Date,
    default: new Date(),
  },
  toaXe: {
    type: Object as PropType<IToaXeResponseBase | null>,
    default: null,
  },
},
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const { ButtonsType } = useButtonCustom();

const emit = __emit;

const isOpen = ref(false);

const app = getCurrentInstance();

const modalId = ref('bang-ke-chi-tiet-xuat-print-modal');

const onPrintingButtonClicked = () => {
  (app.appContext.config.globalProperties as any).$htmlToPaper(modalId.value);
}

__expose({
  isOpen,
});

const dateDisplay = computed(() => {
  if (props.from.getMonth() === props.to.getMonth() + 1) return `Tháng ${props.from.getMonth() + 1} năm ${props.from.getFullYear()}`

  return `Từ tháng ${props.from.getMonth() + 1} năm ${props.from.getFullYear()} đến tháng ${props.to.getMonth() + 1} năm ${props.to.getFullYear()}`
});

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    title: "Bảng kê chi tiết xuất",
    width: "90%",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(DivRow, { class: "mb-2" }, {
        default: _withCtx(() => [
          _createVNode(DivCol, { cols: 10 }),
          _createVNode(DivCol, {
            cols: 2,
            class: "text-end justify-content-end"
          }, {
            default: _withCtx(() => [
              _createVNode(ButtonCustom, {
                "button-type": _unref(ButtonsType).FA_PRINT,
                onClick: onPrintingButtonClicked
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("In phiếu")
                ]),
                _: 1
              }, 8, ["button-type"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        id: modalId.value,
        class: "printing-paper"
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, " Tháng " + _toDisplayString(dateDisplay.value), 1),
            _createElementVNode("p", _hoisted_8, "Xuất tại kho: " + _toDisplayString(__props.kho?.ten_kho), 1)
          ]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, "Tên đối tượng: " + _toDisplayString(__props.toaXe?.ten_toa_xe), 1),
          _createElementVNode("span", _hoisted_12, "Mã đối tượng: " + _toDisplayString(__props.toaXe?.ma_toa_xe), 1),
          _createElementVNode("span", _hoisted_13, "Cấp sửa chữa: " + _toDisplayString(__props.capSuaChua?.ten_cap_sc), 1)
        ]),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(ChiTietXuatTable, { items: __props.items }, null, 8, ["items"])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", null, [
            _createVNode(SignatureCol, { "nguoi-ky": "Thủ kho" })
          ]),
          _createElementVNode("div", null, [
            _createVNode(SignatureCol, { "nguoi-ky": "Người giữ sổ" })
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(SignatureCol, { "nguoi-ky": "TP Tài Chính" })
          ])
        ])
      ], 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})